import { AloftAreaJSON } from '@aloft/shared-objects';
import { syntaxFNMA } from '@aloft/toolkit-shared';

import { extractAdjustmentDescription } from './extractAdjustmentDescription.ts';

export function extractSiteArea(sale: Element): AloftAreaJSON | undefined {
  try {
    return syntaxFNMA.siteSyntax
      .decode(extractAdjustmentDescription(sale, 'SiteArea') ?? '')
      .site?.toJSON();
  } catch (e: unknown) {
    console.warn('Failed to parse site area', e);
    return undefined;
  }
}
